angular.module('mercury.modules.time.compliance', [
  'mercury.modules.time.compliance.payrules'
]);
